import { TArticle } from 'models/common';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import dbService from 'services/database.service';

const useArticle = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [articles, setArticles] = useState<TArticle[]>([]);

  const deleteArticle = async (id: string) => {
    if (articles.length) {
      const index = articles.findIndex((article) => article._id === id);
      articles.splice(index, 1);
      setArticles(articles);
    }

    const path = location.pathname.split('/')[1];
    const idOfArticle = location.pathname.split('/')[3];

    await dbService.removeArticle(id);

    if (path === 'a' || (path === 'c' && idOfArticle)) {
      navigate('/home');
    }
  };

  return { articles, setArticles, deleteArticle };
};

export default useArticle;
